/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Informacja o przetwarzaniu danych osobowych') {
            document.title = 'Informacja o przetwarzaniu danych osobowych';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</b></Typography><br />
                <br /><Typography variant='body2' gutterBottom>Zgodnie z art.13 ust.1 i ust.2 rozporządzenia Parlamentu Europejskiego i rady (UE) 2016/679 z dnia 27 kwietnia 2016r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólnego rozporządzenia o ochronie danych ), informujemy, że: </Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Administratorem Państwa danych osobowych jest PPUH Hayduk Andrzej Wojtaszek-Hayduk, ul. Moniuszki 11, 68-200 Żary. Przedsiębiorstwo zarejestrowane jest w CEIDG; REGON 970030228, NIP 928-000-05-36;  adres poczty elektronicznej: <a href={`mailto:${'biuro@hayduk.pl'}`} target='_blank' className={`${classes.email}`}>{'biuro@hayduk.pl'}</a> </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Administrator nie wyznaczył inspektora ochrony danych osobowych; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Państwa dane pozyskaliśmy:
                        <ul>
                            <li>bezpośrednio od Państwa; </li>
                            <li>ze źródeł publicznych oraz ogólnodostępnych, w tym z Internetu, np. Krajowego Rejestru Sądowego, Centralnej Ewidencji i Informacji o Działalności Gospodarczej. </li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Firma PPUH Hayduk Andrzej Wojtaszek-Hayduk przetwarza następujące kategorie danych:
                        <ul>
                            <li>dane kontaktowe; </li>
                            <li>dane wymagane do identyfikacji na potrzeby zawarcia umowy, wykonania usługi, wystawienia faktury, obsługi posprzedażowej, numery kont w celu rozliczeń między firmą Hayduk a Klientem; </li>
                            <li>dane identyfikacyjne niezbędne do świadczenia usług on-line; </li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom> Cele i podstawa prawna przetwarzania danych<br></br>Państwa dane osobowe będą przetwarzane na podstawie:
                        <ul>
                            <li>art. 6 ust. 1 lit. b RODO, w zakresie jakim jest to konieczne w celu realizacji łączącej nas umowy.</li>
                            <li>art. 6 ust. 1 lit. c RODO, tj. w zakresie niezbędnym do realizacji obowiązków na nas ciążących takich rozliczenia finansowe, w tym podatkowe.</li>
                            <li>art. 6 ust. 1 lit. f RODO, tj. przetwarzanie w zakresie niezbędnym dla realizacji celów wynikających z naszych prawnie uzasadnionych interesów oraz ewentualna konieczność odpierania lub realizacji roszczeń cywilnoprawnych.</li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Podane dane nie będą przekazywane do państwa trzeciego ani organizacji międzynarodowej; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Odbiorcy danych: Obiorcami Państwa danych mogą być zewnętrzne  podmioty upoważnione na podstawie przepisów prawa, jednostki nadrzędne, podmioty świadczące na rzecz Administratora usługi na podstawie umów powierzenia;</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Państwa dane będą przechowywane przez okres potrzebny do realizacji naszych relacji biznesowych w tym umów, zleceń i zamówień - do końca okresu przedawnienia roszczeń (5 lat plus 1 rok lub do czasu wycofania zgody)</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Podając swoje dane osobowe, mają Państwo prawo do wniesienia sprzeciwu wobec przetwarzania, prawo do przenoszenia danych, prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Podający swoje dane ma prawo wniesienia skargi do organu nadzorczego, którym jest Generalny Inspektor Ochrony Danych Osobowych, adres siedziby: ul. Stawki 2, 00-193 Warszawa, w każdej chwili; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Podanie danych osobowych jest dobrowolne, tylko w oparciu o własną niewymuszoną wolę, jednakże w przypadku braku zgody na przetwarzanie danych osobowych Firma nie będzie mogła utrzymywać kontaktu i przekazywać istotnych informacji; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Nie przewidujemy zautomatyzowanego przetwarzania danych osobowych, w tym nie będziemy stosować wobec tych danych profilowania. </Typography></li>
                </ol>
                <br />
                <div id="footer">
                    <Typography variant='body2' gutterBottom>
                        {/* <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-wynajem" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Warunki wynajmu
                            </Button>
                        </a>
                              
                        <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-pobyt" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Regulamin pobytu
                            </Button>
                        </a>
                              
                        <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-pobyt" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Informacja o przetwarzaniu danych osobowych
                            </Button>
                        </a>
                               */}
                        <a href="https://hayduk.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Polityka prywatności
                            </Button>
                        </a>
                              
                    </Typography>
                </div>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
